import React, { useState } from 'react';
import { useGlobalContext } from "../../GlobalContext";
import generateHarianHariRayaPDF from './pdf/harianhariraya';

const HarianHariRaya = () => {
  const { api } = useGlobalContext();

  const hariini = new Date();
  const hariiniString = hariini.toISOString().split('T')[0];

  const [startDate, setStartDate] = useState(hariiniString);
  const [endDate, setEndDate] = useState(hariiniString);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const fetchData = async () => {
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan akhir.");
      return [];
    }

    setIsLoading(true);

    try {
      const response = await api.get(
        `/api/laporan/hariraya/${startDate}/${endDate}`
      );

      console.log("Data diterima dari API:", response.data);

      return response.data.data || response.data || [];
    } catch (error) {
      console.error("Gagal mengambil data laporan V.Belanja:", error);

      if (error.response) {
        alert(
          `Gagal mengambil data: ${error.response.status} - ${
            error.response.data?.message || "Terjadi kesalahan pada server."
          }`
        );
      } else if (error.request) {
        alert(
          "Gagal mengambil data: Tidak ada respons dari server. Pastikan backend berjalan."
        );
      } else {
        alert(`Gagal mengambil data: ${error.message}`);
      }

      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const printToPDF = async () => {
    const data = await fetchData();

    generateHarianHariRayaPDF(
      data, 
      startDate, 
      endDate
    );

  };

  const handleExportExcel = async (e) => {
    e.preventDefault();

    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan akhir.");
      return;
    }

    setIsExporting(true);

    try {
      const resp = await api.get(
        `/api/laporan/vbelanja/excel/${startDate}/${endDate}`,
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([resp.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Laporan_VBelanja_${startDate}_${endDate}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      alert("Excel berhasil diunduh!");
    } catch (error) {
      console.error("Export Excel error:", error);
      alert("Gagal export Excel.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="container mt-3">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card card-info">
            <div className="card-header bg-info text-white">
              <h3 className="card-title">
                Laporan Harian Hari Raya
              </h3>
            </div>

            <form className="form-horizontal">
              <div className="card-body">
                <div className="form-group row d-flex align-items-center">
                  <label
                    htmlFor="tglmulai"
                    className="col-sm-3 col-form-label"
                  >
                    Tanggal
                  </label>

                  <div className="col-sm-4">
                    <input
                      type="date"
                      className="form-control"
                      id="tglmulai"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>

                  <div className="col-auto">
                    <span>s/d</span>
                  </div>

                  <div className="col-sm-4">
                    <input
                      type="date"
                      className="form-control"
                      id="tglsampai"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="card-footer text-right">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={printToPDF}
                  disabled={isLoading || isExporting}
                >
                  {isLoading ? "Memuat Data..." : "Cetak Laporan"}
                </button>

                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={handleExportExcel}
                  disabled={isLoading || isExporting}
                  style={{ marginLeft: "8px" }}
                >
                  {isExporting ? "Mengekspor..." : "Export Excel"}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HarianHariRaya;